import { render, staticRenderFns } from "./ImageAlbum.vue?vue&type=template&id=a27db05a&scoped=true&"
import script from "./ImageAlbum.vue?vue&type=script&lang=js&"
export * from "./ImageAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27db05a",
  null
  
)

export default component.exports